import { CSSProperties, FC } from "react";
import { Checkbox, Table } from "antd";
import { clsx } from "clsx";
import { PricingModel } from "../../../../types/IntelligenceTypes";
import styles from "./PricingModels.module.less";

const { Column } = Table;

interface PricingModelsProps {
    data?: PricingModel[];
    style?: CSSProperties;
}

export const PricingModels: FC<PricingModelsProps> = ({ data, style }) => {
    if (!data?.length) return null;

    return (
        <div style={style}>
            <div className={clsx(styles.tableTitle, "sectionTitle")}>Typical pricing models</div>
            <Table dataSource={data} pagination={false} size="small">
                <Column
                    title="Pricing Models"
                    dataIndex="model"
                    width={334}
                    render={(value) => <Checkbox className={styles.check}>{value}</Checkbox>}
                />
                <Column title="Frequency" dataIndex="frequency" width={334} />
                <Column title="Industry Norms" dataIndex="norms" />
            </Table>
        </div>
    );
};
